import React, { ReactNode } from 'react'

interface ToolbarProps {
  children: ReactNode
  className?: string
}

export const Toolbar: React.FC<ToolbarProps> = ({ children, className = '' }) => {
  return <div className={`toolbar ${className}`}>{children}</div>
}
